// extracted by mini-css-extract-plugin
export default {"root":"Reference_root__X25v6","title":"Reference_title__Vi0FI","subtitle":"Reference_subtitle__+kHo4","content":"Reference_content__n-2lW","cards":"Reference_cards__CyllH"};